import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "conditional"];
  static values = {
    show: Array,
  };

  connect() {
    this.toggle();
  }

  change() {
    this.toggle();
  }

  toggle() {
    const el = this.selectTarget;
    const selected =
      el.type === "checkbox" ? (el.checked ? "true" : "false") : el.value;
    const defaultShowValues = this.hasShowValue ? this.showValue : [];
    this.conditionalTargets.forEach((el) => {
      const customShowValues = el.dataset.conditionalFieldsShowValue;
      let showValues = defaultShowValues;

      if (customShowValues) {
        try {
          showValues = JSON.parse(customShowValues);
        } catch {
          showValues = defaultShowValues;
        }
      }

      const shouldShow = showValues.includes(selected);
      el.classList.toggle("d-none", !shouldShow);
    });
  }
}
